import { makeAutoObservable, toJS } from "mobx";
import AppStore from "../../stores/AppStore";

export interface IRateAssignment {
    id: string; 
   description?:string;
    isActive:boolean;
    midtermReview: {
        status: FeedbackStatus;
        startDate: number;
        endDate: number;
    };
    finalAssessment: {
        status: FeedbackStatus;
        startDate: number;
        endDate: number;
    };
    status:FeedbackStatus;
    feedbackAssignments: Record<string, string[]>; 
    ratedUsersPerAssignmentValues: Record<string, string[]>;
    ratedUsersPerAssignmentLeadership: Record<string, string[]>;
}

export interface ISession {
    id: string; 
   description?:string;
  
}

export const defaultRatingAssignment: IRateAssignment = {
    id: "",
    description: "",
    isActive: false,
    midtermReview: {
        status: "Not Started",
        startDate: Date.now(),
        endDate: Date.now(),
    },
    finalAssessment: {
        status: "Not Started",
        startDate: Date.now(),
        endDate: Date.now(),
    },
    status: "Not Started",
    feedbackAssignments: {}, // Initialize with an empty object for feedback assignments
    ratedUsersPerAssignmentValues: {},
    ratedUsersPerAssignmentLeadership: {},
};

export type FeedbackStatus = "Not Started"|"In Progress" | "Cancelled" | "Completed";

export default class RateAssignment {
    private rateAssignment: IRateAssignment;

    constructor(private store: AppStore, rateAssignment: IRateAssignment) {
        makeAutoObservable(this);
        this.rateAssignment = rateAssignment;
    }

    get asJson(): IRateAssignment {
        return toJS(this.rateAssignment);
    }
}
